import { component as defineComponent } from 'flightjs';
import 'app/lib/load-image';

var entryThumbnail = function() {
    this.attributes({
        image: '[data-entry-thumbnail-image]'
    });

    this.after('initialize', function() {
        var $image = this.select('image');

        $image.loadImage($image.attr('src')).done(function() {
            this.toggleLoaded();
        }.bind(this));
    });

    this.toggleLoaded = function() {
        this.$node.attr('data-image-loaded', true);
    };
};

export default defineComponent(entryThumbnail);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/entry-thumbnail.js